<template>
  <div class="fixed inset-0 flex items-center justify-center z-[99999]">
    <div class="fixed inset-0 bg-gray-800 opacity-75"></div>
    <div class="bg-white p-4 rounded-lg z-10 shadow-md">
      <p class="text-xl font-semibold">Confirmation</p>
      <p>{{ message }}</p>
      <div class="mt-4 flex justify-end">
        <button @click="confirmAction" class="bg-blue-500 text-white px-4 py-2 rounded hover:bg-blue-600 mr-2">
          Confirm
        </button>
        <button @click="cancelAction" class="bg-gray-300 text-gray-800 px-4 py-2 rounded hover:bg-gray-400">
          Cancel
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    message: String,
  },
  methods: {
    confirmAction() {
      // Emit a custom event to confirm the action
      this.$emit('confirm');
    },
    cancelAction() {
      // Emit a custom event to cancel the action
      this.$emit('cancel');
    },
  },
};
</script>

<style scoped>
/* Add your custom styles for the modal here */
</style>
